import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from './DefaultArrows.css';
import { Arrow } from './parts/Arrow';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DefaultArrows = function DefaultArrows(props) {
  var leftAreaWidth = props.leftAreaWidth,
    rightAreaWidth = props.rightAreaWidth,
    showLeft = props.showLeft,
    showRight = props.showRight,
    defaultArrowStyles = props.styles,
    size = props.size,
    clickHandler = props.clickHandler;
  return /*#__PURE__*/_jsx("div", {
    className: styles['default-arrows-container'],
    "data-testid": "DefaultArrows",
    children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, mergeStyles(styles['default-arrows-wrapper'], defaultArrowStyles)), {}, {
      children: [/*#__PURE__*/_jsx(Arrow, {
        direction: -1,
        width: leftAreaWidth,
        clickHandler: clickHandler,
        show: showLeft,
        size: size
      }), /*#__PURE__*/_jsx(Arrow, {
        direction: 1,
        width: rightAreaWidth,
        clickHandler: clickHandler,
        show: showRight,
        size: size
      })]
    }))
  });
};